import * as React from "react";
import WorkflowList from "../../presentations/WorkflowList";

const WorkflowListContainer = (props: any) => {

  const { onEdit } = props;

  const handleOnEdit = (rowData: any) => {
    onEdit(rowData);
  }

  return (
    <div>
      <WorkflowList onEdit={handleOnEdit}></WorkflowList>
    </div>
  );
};

export default WorkflowListContainer;
